import { useSearchParams } from 'react-router-dom';

/** A page's filters, kept in the URL so a filtered page is a link. */
export function useFilterParams() {
  const [params, setParams] = useSearchParams();
  const set = (key: string, value: string | undefined) => {
    const next = new URLSearchParams(params);
    if (value === undefined) {
      next.delete(key);
    } else {
      next.set(key, value);
    }
    setParams(next);
  };
  return { params, set };
}
